export const numColorMap = {
  0: '#ffb100',
  1: '#ffb100',
  2: '#ffb100',
  3: '#ffb100',
  4: '#40A6DB',
  5: '#40A6DB',
  6: '#40A6DB',
  7: '#40A6DB'
}
